// import * as config from 'config';

// ------------------------------------------------------------------------
// Polyfills
// ------------------------------------------------------------------------
require('boot/polyfills');


// ------------------------------------------------------------------------
// Other Libraries
// ------------------------------------------------------------------------


// ------------------------------------------------------------------------
// Vue
// ------------------------------------------------------------------------
require('boot/vue');


// ------------------------------------------------------------------------
// Enable Barba.js Page Transitions
// ------------------------------------------------------------------------
require('barba2');


// ------------------------------------------------------------------------
// Axios
// ------------------------------------------------------------------------
window.axios = require('axios');

// axios.defaults.baseURL = config.API_PREFIX
axios.defaults.headers.common = {
    // 'Authorization': 'Bearer ' + config.API_TOKEN,
    // 'X-CSRF-TOKEN': window.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
};
